/**
 * Copy for the public prescription-upload page, in English and Gujarati.
 *
 * Kept out of the component so the clinic can correct a phrase without touching
 * the form logic. Every key exists in both languages.
 */
export const RX_COPY = {
  en: {
    label: "English",
    overline: "Prescription service",
    title: "Upload your prescription",
    subtitle:
      "Send us a photo of your doctor's prescription. Our team will call you back, confirm the medicines and deliver them to your home.",
    steps: ["Photograph the prescription", "We call you to confirm", "Medicines reach your door"],
    name: "Full name",
    namePlaceholder: "Your name",
    phone: "Mobile number",
    phonePlaceholder: "10-digit mobile number",
    address: "Delivery address",
    addressPlaceholder: "House / flat, street, area, city, pin code",
    knownBack: "Welcome back — we have filled in your details from last time. Please correct anything that has changed.",
    note: "Anything we should know (optional)",
    notePlaceholder: "Best time to call, address area, allergies…",
    file: "Prescription photo or PDF",
    fileHint: "JPG, PNG or PDF. Large photos are compressed automatically.",
    choose: "Choose file",
    change: "Change file",
    consent: "I agree that Immortal Vedas may contact me about this prescription.",
    submit: "Send prescription",
    sending: "Sending…",
    thanksTitle: "Thank you.",
    thanksBody: (phone) => `Our team will call you on ${phone} shortly.`,
    another: "Upload another prescription",
    privacy: "Your prescription is private. Only our clinic team can open it.",
    errName: "Please enter your full name.",
    errPhone: "Please enter a valid 10-digit mobile number.",
    errAddress: "Please enter the full delivery address with a pin code.",
    errFile: "Please attach a photo or PDF of the prescription.",
    errConsent: "Please tick the consent box so we may call you.",
    errBig: "That file is larger than 5 MB. Please send a smaller photo.",
    referral: (code) => `Referred by ${code}`,
  },
  gu: {
    label: "ગુજરાતી",
    overline: "પ્રિસ્ક્રિપ્શન સેવા",
    title: "તમારું પ્રિસ્ક્રિપ્શન અપલોડ કરો",
    subtitle:
      "ડૉક્ટરના પ્રિસ્ક્રિપ્શનનો ફોટો મોકલો. અમારી ટીમ તમને ફોન કરીને દવા નક્કી કરશે અને ઘરે પહોંચાડશે.",
    steps: ["પ્રિસ્ક્રિપ્શનનો ફોટો પાડો", "અમે ફોન કરીને ખાતરી કરીશું", "દવા ઘર સુધી પહોંચશે"],
    name: "પૂરું નામ",
    namePlaceholder: "તમારું નામ",
    phone: "મોબાઇલ નંબર",
    phonePlaceholder: "10 અંકનો મોબાઇલ નંબર",
    address: "ડિલિવરી સરનામું",
    addressPlaceholder: "ઘર / ફ્લેટ, શેરી, વિસ્તાર, શહેર, પિન કોડ",
    knownBack: "પુનઃ સ્વાગત — ગયા વખતની તમારી વિગતો ભરી દીધી છે. કંઈ બદલાયું હોય તો સુધારી લો.",
    note: "કંઈ કહેવું છે? (વૈકલ્પિક)",
    notePlaceholder: "ફોન કરવાનો સમય, વિસ્તાર, એલર્જી…",
    file: "પ્રિસ્ક્રિપ્શનનો ફોટો અથવા PDF",
    fileHint: "JPG, PNG અથવા PDF. મોટા ફોટા આપમેળે નાના કરવામાં આવે છે.",
    choose: "ફાઇલ પસંદ કરો",
    change: "ફાઇલ બદલો",
    consent: "હું સંમત છું કે Immortal Vedas આ પ્રિસ્ક્રિપ્શન અંગે મારો સંપર્ક કરી શકે છે.",
    submit: "પ્રિસ્ક્રિપ્શન મોકલો",
    sending: "મોકલી રહ્યા છીએ…",
    thanksTitle: "આભાર.",
    thanksBody: (phone) => `અમારી ટીમ તમને ${phone} પર થોડી જ વારમાં ફોન કરશે.`,
    another: "બીજું પ્રિસ્ક્રિપ્શન અપલોડ કરો",
    privacy: "તમારું પ્રિસ્ક્રિપ્શન ખાનગી છે. ફક્ત અમારી ક્લિનિક ટીમ જ તેને જોઈ શકે છે.",
    errName: "કૃપા કરીને તમારું પૂરું નામ લખો.",
    errPhone: "કૃપા કરીને માન્ય 10 અંકનો મોબાઇલ નંબર લખો.",
    errAddress: "કૃપા કરીને પિન કોડ સાથે પૂરું ડિલિવરી સરનામું લખો.",
    errFile: "કૃપા કરીને પ્રિસ્ક્રિપ્શનનો ફોટો અથવા PDF જોડો.",
    errConsent: "અમે ફોન કરી શકીએ તે માટે સંમતિ બોક્સ પર ટિક કરો.",
    errBig: "આ ફાઇલ 5 MB થી મોટી છે. કૃપા કરીને નાનો ફોટો મોકલો.",
    referral: (code) => `સંદર્ભ: ${code}`,
  },
};

export const RX_LANGUAGES = ["en", "gu"];
